module.exports = __webpack_public_path__ + "img/bag-sale.21b67848.svg";